import React from 'react';
import openpathConfig from 'openpathConfig';
import { useTranslation } from 'react-i18next';

import { OpBanner } from 'new-components/DLS/OpBanner/OpBanner';

const PRODUCTION_BRANCHES = new Set(['master', 'main']);
const PRODUCTION_ENVIRONMENTS = new Set([
  'prod',
  'prodeu1',
  'prodcan1',
  'prodaus1',
]);

function normalizeBranch(branch: string | undefined): string {
  if (
    !branch ||
    branch === 'unknown' ||
    branch === 'unknown-due-to-codebuild'
  ) {
    return '';
  }
  return branch.replace(/^refs\/heads\//, '').trim();
}

function isProductionBranch(branch: string): boolean {
  return PRODUCTION_BRANCHES.has(branch.toLowerCase());
}

function isProductionEnvironment(env: string | undefined): boolean {
  if (!env) return false;
  return PRODUCTION_ENVIRONMENTS.has(env.toLowerCase());
}

export const BranchDeploymentBanner = () => {
  const { t } = useTranslation();
  const rawBranch = openpathConfig.__GIT_BRANCH__;
  const branch = normalizeBranch(rawBranch);

  if (
    !branch ||
    isProductionBranch(branch) ||
    isProductionEnvironment(openpathConfig.ENV)
  ) {
    return null;
  }

  return (
    <OpBanner
      type="warning"
      title={
        <>
          {t('This environment is running code from branch:')}{' '}
          <strong>{branch}</strong> {t('(not master)')}
        </>
      }
      testId="branch-deployment-banner"
    />
  );
};
